import { render, staticRenderFns } from "./ConventionSectionsMenuItem.vue?vue&type=template&id=d24db300&scoped=true"
import script from "./ConventionSectionsMenuItem.vue?vue&type=script&lang=js"
export * from "./ConventionSectionsMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ConventionSectionsMenuItem.vue?vue&type=style&index=0&id=d24db300&prod&lang=sass"
import style1 from "./ConventionSectionsMenuItem.vue?vue&type=style&index=1&id=d24db300&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24db300",
  null
  
)

export default component.exports